import { __ } from "@wordpress/i18n";
import { useState } from "@wordpress/element";
import TopicResponseSection from "./topic-response";
import ConvertSection from "./convert";
import { Tabs } from "@/components/tabs";
import { PluginRequired } from "@/components/plugin-required";
import {css} from "@/utils/css";

export default function BBPress() {
    const sections = [
        {
            value: "topic-to-post",
            label: __("Topic to Post", "antimanual"),
            title: __("Convert closed Topic to Post", "antimanual"),
            description: __("AI analyzes the closed Topics, including all replies, to create clear, well-structured posts. These posts summarize the original problem, solutions, and key insights, turning closed topics into comprehensive resources for future reference.", "antimanual"),
            element: <ConvertSection />,
        },
        {
            value: "ai-answer",
            label: __("AI Answer", "antimanual"),
            title: __("AI-Generated Answers for bbPress Topics", "antimanual"),
            description: __("Enhance your forum's user experience by providing AI-generated answers to user questions based on the content of your bbPress topics. This feature leverages advanced AI capabilities to deliver accurate and relevant responses, helping users find the information they need quickly and efficiently.", "antimanual"),
            element: <TopicResponseSection />,
        },
    ];

    const [activeTab, setActiveTab] = useState(sections[0]);

    return (
        <PluginRequired plugin="bbpress">
            <Tabs standalone tabs={sections} activeTab={activeTab.value} onTabChange={(newTab) => setActiveTab(sections.find(s => s.value === newTab) || sections[0])} />
            <div className={css("pb-5 pt-2 px-2")}>
                <h2>{activeTab.title}</h2>
                <p>{activeTab.description || ""}</p>
            </div>
            <div className={css("panel")}>{activeTab.element}</div>
        </PluginRequired>
    );
}
